function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".bespoken_power_icon_svg__cls-1{fill:#393c51}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "bespoken_power_icon_svg__Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "bespoken_power_icon_svg__Capa_6",
  "data-name": "Capa 6"
}, React.createElement("path", {
  className: "bespoken_power_icon_svg__cls-1",
  d: "M8.92 20A8.92 8.92 0 012.61 4.77a1.37 1.37 0 111.94 1.94 6.18 6.18 0 108.74 0 1.37 1.37 0 111.94-1.94A8.92 8.92 0 018.92 20z"
}), React.createElement("path", {
  className: "bespoken_power_icon_svg__cls-1",
  d: "M8.92 9.61a1.37 1.37 0 01-1.37-1.38V1.37a1.37 1.37 0 112.74 0v6.86a1.37 1.37 0 01-1.37 1.38z"
})));

var SvgBespokenPowerIcon = function SvgBespokenPowerIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 17.84 20"
  }, props), _ref, _ref2);
};

export default SvgBespokenPowerIcon;